var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpb-lead"},[_vm._t("top"),_c('Lead',_vm._b({},'Lead',{ ..._vm.data, ..._vm.options },false)),_vm._t("bottom")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }